import { Map } from 'immutable';
import { createSelector } from 'reselect';

import {
  getCompanyOneTimeEventDone,
  getCurrentLocationTierName,
  getCurrentUserIsManagerial,
  getOnboardingResponses,
  getUserOneTimeEventDone,
} from 'selectors/session';

import {
  AnonDataState,
  DashboardBannerState,
  DashboardBannerType,
  ScheduleRosterState,
} from 'features/productGrowth/types';

import { getUrlParamValue } from 'util/urlParams';

import { TIER_NAMES } from '../tiers/constants';

export const selectShowC2CDialogFromURL = createSelector(
  getCurrentLocationTierName,
  getCurrentUserIsManagerial,
  (currentLocationTierName, currentUserIsManagerial) =>
    currentUserIsManagerial &&
    currentLocationTierName !== TIER_NAMES.BASIC &&
    getUrlParamValue('show-c2c') === 'true'
);

export const selectUploadDocumentPending = (state: any) =>
  state.get('productGrowth').uploadDocumentIsPending;

export const selectUploadDocumentSuccess = (state: any) =>
  state.get('productGrowth').uploadDocumentSuccess?.message?.status ===
  'success';

export const selectUploadSchedulePending = (state: any) =>
  state.get('productGrowth').uploadScheduleIsPending;

export const selectScheduleRoster = (state: any): ScheduleRosterState =>
  state.get('productGrowth').scheduleRoster;

export const selectDashboardBannerState = (state: any): DashboardBannerState =>
  state.get('productGrowth').dashboardBanner;

export const selectDismissedDashboardBanner = (
  state: any,
  bannerType?: DashboardBannerType
) => {
  if (bannerType === 'scheduling') {
    return getUserOneTimeEventDone(
      state,
      'dismissed_scheduling_dashboard_banner'
    );
  }

  if (bannerType?.includes('price_sensitivity')) {
    return getUserOneTimeEventDone(
      state,
      'dismissed_price_sensitivity_dashboard_banner'
    );
  }

  return false;
};

export const selectPayrollCrossSellPayrollSelected = (
  state: Map<string, any>
) => getCompanyOneTimeEventDone(state, 'payroll_cross_sell_payroll_selected');

export const selectAnonData = (state: Map<string, any>): AnonDataState | null =>
  state.get('productGrowth').anonData;

export const selectPayrollInterestedSignup = (state: any) =>
  getOnboardingResponses(state)?.get('use_type')?.includes('payroll');

export const selectPayrollSoftwareName = (state: any) =>
  getOnboardingResponses(state)?.get('payroll_software_name');

export const selectTaskManagerCheckout = (state: any): boolean =>
  state.get('productGrowth').taskManagerCheckout;

export const selectPayrollCheckout = (state: any): boolean =>
  state.get('productGrowth').payrollCheckout;
